import { Action } from '../core/Action';

const REGISTER_BIZ = { entity: 'REGISTER_BIZ', action: Action.HANDLE };
const CONFIRM_REGISTER_BIZ = { entity: 'CONFIRM_REGISTER_BIZ', action: Action.HANDLE };

export { CONFIRM_REGISTER_BIZ, REGISTER_BIZ };
